export const navigationTranslations = {
  // Header
  'nav.home': {
    ru: 'Главная',
    kz: 'Басты',
    en: 'Home'
  },
  'nav.about': {
    ru: 'О центре',
    kz: 'Орталық туралы',
    en: 'About'
  },
  'nav.aboutCenter': {
    ru: 'О центре',
    kz: 'Орталық туралы',
    en: 'About Center'
  },
  'nav.director': {
    ru: 'Руководитель',
    kz: 'Басшы',
    en: 'Director'
  },
  'nav.legalActs': {
    ru: 'Нормативные правовые акты',
    kz: 'Нормативтік құқықтық актілер',
    en: 'Legal Acts'
  },
  'nav.structure': {
    ru: 'Структура',
    kz: 'Құрылым',
    en: 'Structure'
  },
  'nav.services': {
    ru: 'Услуги',
    kz: 'Қызметтер',
    en: 'Services'
  },
  'nav.team': {
    ru: 'Специалисты',
    kz: 'Мамандар',
    en: 'Team'
  },
  'nav.compliance': {
    ru: 'Комплаенс служба',
    kz: 'Комплаенс қызметі',
    en: 'Compliance Service'
  },
  'nav.presidentialAddress': {
    ru: 'Послание президента',
    kz: 'Президент жолдауы',
    en: 'Presidential Address'
  },
  'nav.news': {
    ru: 'Новости',
    kz: 'Жаңалықтар',
    en: 'News'
  },
  'nav.contacts': {
    ru: 'Контакты',
    kz: 'Байланыстар',
    en: 'Contacts'
  },
  'nav.login': {
    ru: 'Вход',
    kz: 'Кіру',
    en: 'Login'
  },
  'nav.logout': {
    ru: 'Выход',
    kz: 'Шығу',
    en: 'Logout'
  },
  'nav.register': {
    ru: 'Регистрация',
    kz: 'Тіркелу',
    en: 'Register'
  },
  'nav.presidential': {
    ru: 'Послание Президента',
    kz: 'Президент Жолдауы',
    en: 'Presidential Address'
  },
  'nav.profile': {
    ru: 'Профиль',
    kz: 'Профиль',
    en: 'Profile'
  },
  'nav.changePassword': {
    ru: 'Изменить пароль',
    kz: 'Құпия сөзді өзгерту',
    en: 'Change Password'
  },
  'nav.management': {
    ru: 'Управление',
    kz: 'Басқару',
    en: 'Management',
  },
};
